<div class="container-fluid py-3">
  <div class="mb-3">
    <h3 class="mb-1">{{ 'i18n.domain.analytics.statistic-events.title' | translate }}</h3>
    <p class="text-body-secondary mb-0">{{ 'i18n.domain.analytics.statistic-events.subtitle' | translate }}</p>
  </div>

  <div class="row align-items-center mb-2">
    <div class="col-auto">
      <label class="form-label mb-0" for="statistic-events-vehicle-id">{{ 'i18n.domain.analytics.statistic-events.vehicle-id' | translate }}</label>
    </div>
    <div class="col-auto">
      <input id="statistic-events-vehicle-id" type="number" class="form-control" min="1" [(ngModel)]="vehicleId" />
    </div>
    <div class="col-auto">
      <button class="btn btn-primary" type="button" [disabled]="!vehicleId" (click)="onLoadEvents()">
        {{ 'i18n.domain.analytics.statistic-events.load' | translate }}
      </button>
    </div>
  </div>

  <div class="control-section">
    <ejs-grid #grid
      class="grid-with-toolbar"
      width='100%'
      rowHeight='38'
      [dataSource]='data'
      [allowSorting]='true'
      [filterSettings]='filterSettings'
      [allowFiltering]='true'
      [allowPaging]='true'
      [pageSettings]='pageSettings'
      [editSettings]='editSettings'
      (actionBegin)="actionBegin($event)"
      (actionComplete)="actionComplete($event)"
      (commandClick)="commandClick($event)">
      <e-columns>
        @for (column of gridColumns; track column.field) {
          <e-column
            [headerText]='column.headerKey | translate'
            [field]='column.field'
            [type]='column.type ?? "string"'
            [visible]='isColumnVisible(column.field, column.visible)'
            [width]='column.width'
            [clipMode]='column.clipMode'
            [isPrimaryKey]='isPrimaryKeyColumn(column.field)'
            [allowFiltering]='isFilteringAllowed(column.allowFiltering)'
            [filter]='getColumnFilter(column.field, column.allowFiltering)'>
            @if (column.filter?.kind === 'enum') {
              <ng-template #filterItemTemplate let-data>{{formatFilter(data, column.field, column.filter) | translate}}</ng-template>
              <ng-template #template let-data>
                <span>{{formatColumnValue(column.field, data)}}</span>
              </ng-template>
            } @else if (column.formatValue) {
              <ng-template #template let-data>
                <span>{{formatColumnValue(column.field, data)}}</span>
              </ng-template>
            }
          </e-column>
        }
        <e-column headerText="" [commands]='gridCommands'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>

<app-statistic-event-detail-dialog [event]="selectedEvent" [(visible)]="showDetailDialog"></app-statistic-event-detail-dialog>
